<template>
  <div>
    <div :class="$style.outer" v-if="editable">
      <div :class="$style.tags">
        <div :class="$style.tag" :style="tagStyle" v-for="(item, index) in value" :key="item">
          <span>{{ optionsMap[item] ? optionsMap[item].label : item }}</span>
          <i :class="$style.icon" class="el-icon-delete" @click="onDel(index)"></i>
        </div>
      </div>
      <el-popover
        placement="right-start"
        trigger="click">
        <div v-if="leftOptions.length" :class="$style.MaxHeight" class="smallScrollbar">
          <div v-for="item in leftOptions" :key="item.value"
            :class="$style.add__item"
            @click="onAdd(item)"
          >{{ item.label}}</div>
        </div>
        <div v-else>{{ emptyText }}</div>
        <div slot="reference" :class="$style.add__icon" ref="add">
          <i  class="el-icon-circle-plus-outline"></i>
        </div>
      </el-popover>
    </div>
    <div v-else :class="$style.text">
      <template v-if="showTextType === 'curators'">
        <div v-for="(item, index) in data.curators" :key="index">
          {{ item.full_name | formatName }}  <span v-if="showIsread">（{{item.isread ? '已读' : '未读'}}）</span>
        </div>
      </template>
      <div :class="$style.tags" v-else>
        <span v-if="!value.length">--</span>
        <div :class="$style.tag" :style="tagStyle" v-for="item in value" :key="item">
          <span>{{ optionsMap[item] ? optionsMap[item].label : item }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    form: Object,
    data: Object,
    editable: {
      type: Boolean,
      default: true
    },
    options: {
      type: Array,
      default: () => []
    },
    showIsread: {
      type: Boolean,
      default: true
    },
    tagStyle: String,
    emptyText: {
      type: String,
      default: '暂无数据'
    },
    showTextType: String,
  },
  inject: ['detail'],
  filters: {
    formatName (val) {
      return val?.replace(/-/g, '/')
    }
  },
  computed: {
    optionsMap () {
      let map = {}
      this.options.forEach(a => map[a.value] = a)
      return map
    },
    leftOptions () {
      return this.options.filter(a => !this.value.includes(a.value))
    },
  },
  methods: {
    onDel(index) {
      let arr = [...this.value]
      arr.splice(index, 1)
      this.$emit('input', arr)
    },
    onAdd (item) {
      this.$nextTick(() => {
        this.$refs.add.click()
      })
      let arr = [...this.value]
      arr.push(item.value)
      this.$emit('input', arr)
    }
  }
}
</script>

<style lang="scss" module>
.outer, .tags, .tag {
  display: flex;
  align-items: center;
}
.tags {
  flex-wrap: wrap;
}
.tag {
  padding: 3px 10px;
  color: #fff;
  background-color: #f00;
  font-size: 13px;
  line-height: 16px;
  margin-right: 10px;
  border-radius: 3px;
  margin-bottom: 2px;
}
.icon {
  cursor: pointer;
  margin-left: 5px;
  margin-top: 1px;
}
.add__icon {
  cursor: pointer;
  color: #000;
  font-size: 20px;
}
.add__item {
  line-height: 30px;
  padding: 0 5px;
  color: #101010;
  border-radius: 2px;
  cursor: pointer;
  &:hover {
    background-color: #e6f2f2;
    color: teal;
  }
}
.text {
  font-size: 13px;
}

.MaxHeight {
  max-height: 188px;
  overflow: auto;
}
</style>
